var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveAudit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0833 5.86797C17.0833 2.50964 16.3 1.66797 13.15 1.66797H6.85C3.7 1.66797 2.91667 2.50964 2.91667 5.86797V15.2513C2.91667 17.468 4.13333 17.993 5.60833 16.4096L5.61667 16.4013C6.3 15.6763 7.34167 15.7346 7.93333 16.5263L8.775 17.6513C9.45 18.543 10.5417 18.543 11.2167 17.6513L12.0583 16.5263C12.6583 15.7263 13.7 15.668 14.3833 16.4013C15.8667 17.9846 17.075 17.4596 17.075 15.243V9.16797",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 5.83203H13.3333",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.16797H12.5",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveAudit);
export default __webpack_public_path__ + "static/media/activeAudit.87bdad25d718aef817628b8ffee78404.svg";
export { ForwardRef as ReactComponent };